
import {initWebComponent} from "@/helpers/web-component-helper";
import {DragZoom} from "ol/interaction";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Zoom via rechthoek" data-icon="fa fa-vector-square">`;

let dragZoom

export class OlDragZoomComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {

            if(dragZoom !== undefined) {
                // //// console.log(dragZoom.getActive())
            }

            if(dragZoom === undefined || !dragZoom.getActive()) {
                dragZoom = new DragZoom({
                    condition: () => {
                        return true
                    }
                })

                window.map.addInteraction(dragZoom);
                this.firstChild.firstChild.classList.add('active')
                dragZoom.on('boxend', () => {
                    this.firstChild.firstChild.classList.remove('active')
                    dragZoom.setActive(false)
                    window.map.removeInteraction(dragZoom);
                })
            } else {
                this.firstChild.firstChild.classList.remove('active')
                dragZoom.setActive(false)
                window.map.removeInteraction(dragZoom);
            }

        });
    }
}

